import React from "react";
import css from "./index.module.scss";
import Head from "next/head";
import Header from "sections/header/index.jsx";
import Footer from "sections/footer";
import Link from "next/link";

export default function PrivacyPolicy({ }) {
  let title = "Raffle Terms | X";
  let description = "";


  return (
    <div className="root">
      <Head>
        <title>{title}</title>

        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta property="og:title" content={title} />
      </Head>
      <Header/>
      <main>
        <section>
          <div className="sectionInner">
            <h1>Raffle Competition Terms</h1>
            <ol>
              <li>A Bad Think’s X Marks The Site Scavenger Hunt Raffle Competition is open to any person who signs up on the website “xmarksthe.site.” </li>
              <li>This competition is promoted by Deviate Labs (“Promoter”) in partnership with A Bad Think.</li>
              <li>There is no entry fee and no purchase necessary to enter this competition.</li>
              <li>By entering this competition, an entrant is indicating his/her agreement to be bound by these terms and conditions.</li>
              <li>The opening date of the scavenger hunt competition is 19:00 GMT of 08/01/2022 and the closing date is 23:59 GMT of 10/01/2022 (the &quot;Entry Period&quot;). No bulk, consumer group or third-party entries will be accepted. Entries disallowed due to technical issues shall not be included in the draw. To be eligible for prizes, entries must be received within the specified Entry Period.</li>
              <li>No responsibility can be accepted for entries not received for whatever reason.</li>
            </ol>

            <h2>Competition Rules</h2>
            <p>The rules of the competition and how to enter are as follows:</p>
            <ol>
              <li>You must register to answer challenges and be eligible for prizes.</li>
              <li>You may complete as many of the challenges as you can find in the infinitely looping art. There are ten challenges in total. The more challenges you complete, the more raffle entries you receive and increase your chances of winning a prize. </li>
              <li>You may also earn entries through special achievements, such as completing at least five challenges or completing all ten challenges. Follow the instructions outlined on your <a href="/profile">account page</a>.</li>
              <li>There will be ten winners selected while prize supplies last. The prizes are listed here.</li>
              <li>The prizes are as stated, and no cash or other alternatives will be offered.</li>
              <li>No prize is transferable. Prize is subject to availability and we reserve the right to substitute any prize with another of equivalent value without giving notice.</li>
              <li>The winners will be chosen at random from all entries received and verified by the Promoter and/or its agents. The more entries you receive by completing challenges, the greater your chance of being selected as a winner.</li>
              <li>The winners will be notified via email within 14 days of the closing date. If a winner cannot be contacted or does not claim the prize within 48 hours of notification, we reserve the right to withdraw the prize from the winner and pick a replacement winner. We reserve the right to extend the notification period at any time.</li>
              <li>Please allow up to 90 days to receive/redeem your prize.</li>
              <li>The Promoter’s decision regarding all matters of the competition will be final and no correspondence will be entered.</li>
              <li>The competition and these terms and conditions will be governed by United States law and any disputes will be subject to the exclusive jurisdiction of same.</li>
              <li>The names of the winners will be made available after the conclusion of the competition. To obtain this information contact Promoter at the following email address: abadthinkdl@gmail.com.</li>
              <li>Any personal data relating to participants will be used solely for the purposes of this promotion. Data may be provided to a third-party fulfillment service provider where appropriate for the purposes of administering the prize but will not be disclosed to a third party for any other purpose without the individual’s prior consent.</li>
              <li>The Promoter is Deviate Labs [www.deviatelabs.com, 8605 Santa Monica Blvd, Ste 93568, Los Angeles, California 90069].</li>
            </ol>
            <p><em>This promotion is in no way sponsored, endorsed or administered by, or associated with, Instagram or Facebook.</em></p>

          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
